import React from "react";
import { Button, Input, styled, Flex } from "@100mslive/roomkit-react";
import { isStreamingKit } from "../../common/utils";

const PreviewName = ({ firstName, lastName, onFirstNameChange, onLastNameChange, onJoin, enableJoin }) => {
  const formSubmit = e => {
    e.preventDefault();
  };
  const fullName = `${firstName || ""} ${lastName || ""}`.trim();
  return (
    <Form onSubmit={formSubmit}>
      <Flex css={{ width: "100%", gap: "$4", flexDirection: "column" }}>
        <Flex css={{ width: "100%", gap: "$4" }}>
          <Input
            required
            id="firstName"
            css={{ flex: 1 }}
            value={firstName || ""}
            onChange={e => onFirstNameChange(e.target.value.trimStart())}
            placeholder="First Name"
            autoFocus
            autoComplete="given-name"
          />
          <Input
            required
            id="lastName"
            css={{ flex: 1 }}
            value={lastName || ""}
            onChange={e => onLastNameChange(e.target.value.trimStart())}
            placeholder="Last Name"
            autoComplete="family-name"
          />
        </Flex>
        <Button type="submit" disabled={!fullName || !enableJoin} onClick={onJoin} css={{ width: "100%" }}>
          {isStreamingKit() ? "Join Studio" : "Join Room"}
        </Button>
      </Flex>
    </Form>
  );
};

const Form = styled("form", {
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: "$4",
  maxWidth: "500px",
});

export default PreviewName;
